import { useState, ReactNode } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="min-h-screen bg-ivory font-sans">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />
      <Header collapsed={collapsed} />
      <main
        className={`pt-[72px] min-h-screen transition-all duration-300 ${collapsed ? 'pl-[72px]' : 'pl-[260px]'}`}
      >
        <div className="p-6">
          {children}
        </div>
      </main>
    </div>
  );
}
